export const QuestionClassTypes = [
    {
        text: 'Class 1',
        value: 1
    },
    {
        text: 'Class 2',
        value: 2
    },
    {
        text: 'Class 3',
        value: 3
    },
]
export const AutoCalculationOperators = [
    {
        text: 'Summation (+)',
        value: '+'
    },
    {
        text: 'Subtraction (-)',
        value: '-'
    },
    {
        text: 'Percentage (%)',
        value: '%'
    },
    {
        text: 'Percentage Of',
        value: '%of'
    }
]

export const AutoCalculationOperatorsForAdmin = [
    {
        text: 'Summation (+)',
        value: '+'
    },
    {
        text: 'Subtraction (-)',
        value: '-'
    }
   
]

export const InputTypes = [
    {
        text: 'Textbox',
        value: 1
    },
    {
        text: 'Numeric',
        value: 2
    },
    {
        text: 'Datepicker',
        value: 3
    },
    {
        text: 'Dropdown',
        value: 4
    },
    {
        text: 'Radio button',
        value: 5
    },
    {
        text: 'Checkbox',
        value: 6
    },
    {
        text: 'Admin Level',
        value: 7
    }
]
export const Operators = [
    {
        text: 'Equals to ',
        value: '='
    },
    {
        text: 'Not equals to ',
        value: '!='
    },
    {
        text: 'Less than',
        value: '<'
    },
    {
        text: 'Greater than',
        value: '>'
    },
    {
        text: 'Less than equals to',
        value: '<='
    },
    {
        text: 'Greater than equals to',
        value: '>='
    }
]


// WEBPACK FOOTER //
// ./src/constants/data.js